import { FPageFlag } from '../mdl/f-page';
import { UIViewAddSpec } from '../ui/view';
import { YFlags } from '../y/types';

export type BlockMaker = (block: { type: string }, section: HTMLElement, promises: Promise<any>[], id: string, page_flags: YFlags<FPageFlag>) => UIViewAddSpec | undefined

export const block_registry: { [type: string]: BlockMaker } = {};

export function blkRegister<T extends { type: string }>(type: T['type'], maker: (b: T, section: HTMLElement, promises: Promise<any>[], id: string, page_flags: YFlags<FPageFlag>) => UIViewAddSpec | undefined) {
    block_registry[type] = maker as BlockMaker;
}
